import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { useDispatch } from "react-redux";
import { changePassword } from "../../features/auth/authSlice";
import { toast } from "react-toastify";

const ChangePassword = (props) => {
  const { setShowModal } = props;

  const dispatch = useDispatch();
  const decodedToken = useDecodedToken();

  const [errors, setErrors] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");

  const [oldPassword, setOldShowPassword] = useState(false);
  const [newPassword, setNewShowPassword] = useState(false);
  const [conPassword, setConShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      setErrors({ confirm_password: "Passwords do not match" });
      return;
    }

    const clientData = {
      user_id: decodedToken?.UsrId,
      old_password: formData.old_password,
      new_password: formData.new_password,
      confirm_password: formData.confirm_password,
    };

    dispatch(changePassword(clientData))
      .unwrap()
      .then((result) => {
        if (result.status) {
          toast.success(result.message);

          setFormData({
            old_password: "",
            new_password: "",
            confirm_password: "",
          });

          setErrors({});
          setErrorData([]);
          setLoginError("");

          if (setShowModal) setShowModal(false);
        } else {
          setLoginError(result.message || "Something went wrong");
          setErrorData(result.form_err || []);
        }
      })
      .catch((err) => {
        setLoginError(err?.message || "Error occurred");
        setErrorData(err?.form_err || []);
        toast.error(err?.message || "Error occurred");
      });
  };

  // ✅ MAP ERRORS
  const mapErrors = (errorData) => {
    const errorMap = {};

    (errorData || []).forEach((error) => {
      if (!errorMap[error.param]) {
        errorMap[error.param] = error.msg;
      }
    });

    return errorMap;
  };
  useEffect(() => {
    setErrors(mapErrors(errorData));
  }, [errorData]);
  const handleTogglePassword = () =>
    setOldShowPassword((prev) => !prev);

  const handleToggleNewPassword = () =>
    setNewShowPassword((prev) => !prev);

  const handleToggleConPassword = () =>
    setConShowPassword((prev) => !prev);

  return (
    <div className="row justify-content-center">
      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-6">
            <h4>Change Password</h4>
          </div>
        </div>
      </div>

      <div className="col-md-12 col-lg-12 col-xl-6">
        <div className="card">
          <div className="card-body">
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td className="w-25 p-3">Old Password:</td>
                  <td>
                    <div className="position-relative mb-3">
                      <input
                        type={oldPassword ? "text" : "password"}
                        className="form-control pe-5"
                        name="old_password"
                        placeholder="Enter Old Password"
                        value={formData.old_password}
                        onChange={handleChange}
                        autoComplete="off"
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-0 text-muted"
                        onClick={handleTogglePassword}
                      >
                        <i className={`ri-${oldPassword ? "eye-off-fill" : "eye-fill"}`}></i>
                      </button>

                      {errors.old_password && (
                        <div className="text-danger">{errors.old_password}</div>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-3">New Password:</td>
                  <td>
                    <div className="position-relative mb-3">
                      <input
                        type={newPassword ? "text" : "password"}
                        className="form-control pe-5"
                        name="new_password"
                        placeholder="Enter New Password"
                        value={formData.new_password}
                        onChange={handleChange}
                        autoComplete="off"
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-0 text-muted"
                        onClick={handleToggleNewPassword}
                      >
                        <i className={`ri-${newPassword ? "eye-off-fill" : "eye-fill"}`}></i>
                      </button>

                      {errors.new_password && (
                        <div className="text-danger">{errors.new_password}</div>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-3">Confirm Password:</td>
                  <td>
                    <div className="position-relative mb-3">
                      <input
                        type={conPassword ? "text" : "password"}
                        className="form-control pe-5"
                        name="confirm_password"
                        placeholder="Enter Confirm Password"
                        value={formData.confirm_password}
                        onChange={handleChange}
                        autoComplete="off"
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-0 text-muted"
                        onClick={handleToggleConPassword}
                      >
                        <i className={`ri-${conPassword ? "eye-off-fill" : "eye-fill"}`}></i>
                      </button>

                      {errors.confirm_password && (
                        <div className="text-danger">{errors.confirm_password}</div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <Button
                      variant="primary"
                      onClick={handleSubmit}
                      disabled={
                        !formData.old_password ||
                        !formData.new_password ||
                        !formData.confirm_password
                      }
                    >
                      Update
                    </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;